import { render, staticRenderFns } from "./FlaggingSuccessDialog.vue?vue&type=template&id=e54efdae&scoped=true"
import script from "./FlaggingSuccessDialog.vue?vue&type=script&lang=js"
export * from "./FlaggingSuccessDialog.vue?vue&type=script&lang=js"
import style0 from "./FlaggingSuccessDialog.vue?vue&type=style&index=0&id=e54efdae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e54efdae",
  null
  
)

export default component.exports